import React, { ReactElement, ReactNode } from 'react';

import styles from './styles.module.scss';

import { InfoCircle, Loader, TableDataNotFound } from 'components';
import { TableHeader, TableRow } from './components';

import { generateUniqId } from 'helpers';
import { FormatUtils } from 'utils';
import { IOrganizationTrends } from '../../../../../../../../types/interfaces';
import { TableProBlur } from '../../../OrganizationTreasury/components/DaoAssetsTable/components/TableProBlur';

interface ITrendsTableProps {
    title: string;
    lastUpdate?: string | null;
    infoText?: string;
    tableHeaderData: any; //ICommonTableHeader<IOrganizationTrends, K>[];
    tableRowsData: IOrganizationTrends[];
    loading?: boolean;
    error?: string | null;
    headContent?: ReactNode;
    showBlur?: boolean;
    blurTitle?: string;
    blurSubtitle?: string;
}
const trendsMock: IOrganizationTrends[] = [
    {
        timePeriod: 'Current',
        total24Hours: 1245,
        total7Days: 8920,
        total30Days: 37850,
        total6Months: 215600,
    },
    {
        timePeriod: 'Previous',
        total24Hours: 980,
        total7Days: 7650,
        total30Days: 32400,
        total6Months: 198400,
    },
    {
        timePeriod: 'Current',
        total24Hours: 1560,
        total7Days: 10240,
        total30Days: 41200,
        total6Months: 228300,
    },
    {
        timePeriod: 'Previous',
        total24Hours: 1320,
        total7Days: 9240,
        total30Days: 38700,
        total6Months: 210800,
    },
];

export const TrendsTable = ({
    title,
    lastUpdate,
    infoText,
    tableHeaderData,
    tableRowsData,
    loading,
    headContent,
    showBlur,
    blurTitle = '',
    blurSubtitle = '',
}: ITrendsTableProps): ReactElement => {
    const dataToRender = showBlur ? trendsMock : tableRowsData;
    const currentData = dataToRender.find((t) => t.timePeriod === 'Current');
    const priorData = dataToRender.find((t) => t.timePeriod === 'Previous');

    return (
        <div className={styles.content}>
            <div className={styles.headSection}>
                <div className={styles.textSection}>
                    <h4>{title}</h4>
                    <InfoCircle tooltipText={infoText} className={styles.infoIcon} />
                    {lastUpdate && <h5>Last Update: {FormatUtils.getFormattedDate(lastUpdate)}</h5>}
                </div>
                {headContent}
            </div>

            <div className={`${styles.tableWrapper} ${showBlur && styles.tableBlurWrapper}`}>
                {dataToRender.length > 0 && (
                    <div className={styles.tableContainer}>
                        <TableHeader tableHeaderData={tableHeaderData} />
                        <TableRow
                            key={generateUniqId()}
                            tableHeaderData={tableHeaderData}
                            rowItems={currentData}
                            priorData={priorData}
                        />
                        <TableRow key={generateUniqId()} tableHeaderData={tableHeaderData} rowItems={priorData} />
                        {showBlur && <TableProBlur title={blurTitle} description={blurSubtitle} />}
                    </div>
                )}
            </div>

            {!showBlur && loading && dataToRender.length === 0 && <Loader size={40} className={styles.loaderBox} />}
            {!showBlur && dataToRender.length === 0 && !loading && (
                <TableDataNotFound forTable overflowMarginsSecondVariant />
            )}
        </div>
    );
};
